import * as React from 'react'
import { CloseButton, CloseContainer, FileContainer, Info } from './style'

interface FilenameWithIconProps {
  name: string
  children: React.ReactElement
  onClose?: () => void
  onClick?: () => void
}

const FilenameWithIcon: React.FC<FilenameWithIconProps> = ({ name, children, onClick, onClose }) => (
  <FileContainer isLink={typeof onClick === 'function'}>
    <span onClick={onClick}>{children}</span>
    <Info onClick={onClick}>{name}</Info>
    {typeof onClose === 'function' ? (
      <CloseContainer
        onClick={(e) => {
          e.stopPropagation()
          onClose()
        }}
      >
        <CloseButton size="sm" />
      </CloseContainer>
    ) : null}
  </FileContainer>
)

export default FilenameWithIcon
